import React from 'react';

export function TagComponent(props){
    return (
        <p className="bg-purple-600 bg-opacity-25  m-1 rounded-md sm:text-xl sm:p-1 ...">{props.data}</p>
    );
}